import { atom } from 'jotai';
import { CropType } from 'types';

export const croptypes = atom<CropType[]>([]);
